import React from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import App from './App';
import ProtectedRoute from './components/Routes/ProtectedRoute';
import { Login } from './pages/login/Login';
import PublicRoute from './components/Routes/PublicRoute';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import SlotBooking from './pages/slotBooking/SlotBooking';
import UserFormNew from './pages/UserForm/UserFormNew';
import PaymentSuccess from './pages/PaymentSuccess/PaymentSuccess';
import PaymentFailure from './pages/PaymentSuccess/PaymentFailure';
import TermsAndCondtion from './pages/terms-and-condition/terms-and-condition';
import PrivacyPolicy from './pages/policy/privacy-policy';
import Signdoc from './pages/UserForm/signdoc';
import UpdateEmployeeDocuments from './pages/UserForm/UpdateEmployeeDocuments';

const AppWrapper = () => {
  let location = useLocation();

  React.useEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }

    window.scrollTo(0, 0);
  }, [location]);

  return (
    <>
      <ScrollToTop />
      <Routes>
        {/* Standalone Public Route - Accessible even when logged in for easy testing/access */}
        <Route path="/update-documents/:taxformId" element={<UpdateEmployeeDocuments />} />

        {/* Public Routes - Redirect to dashboard if logged in */}
        <Route element={<PublicRoute />}>
          <Route path="/" element={<Login />} />
          <Route path="/form" element={<UserFormNew />} />
          <Route path="/document-signature/:id/:taxformId" element={<Signdoc />} />
          <Route path="/company-document-signature/:id/:taxformId" element={<Signdoc />} />
          <Route path="/terms-conditions" element={<TermsAndCondtion />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/payment-sucess/:taxformId" element={<PaymentSuccess />} />
          <Route path="/payment-sucess" element={<PaymentSuccess />} />
          <Route path="/cancel" element={<PaymentFailure />} />
          <Route path="/slot-booking/:taxpayerId" element={<SlotBooking />} />
        </Route>

        {/* Protected section */}
        <Route element={<ProtectedRoute />}>
          <Route path="*" element={<App />} />
        </Route>
      </Routes>
    </>
  );
};

export default AppWrapper;
